export const publishRegion = `mutation ($model: PublishRegionRequest!) {
    publishRegion(input: $model)
  }`;
